import '@/framework/styles/index.scss' // global css
import '@/config/styles/theme-custom/theme/index.css'
import Element from 'element-ui'
import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import Vue from 'vue'
import App from './App'
import * as filters from './config/filters' // global filters
import '@/framework/icons' // icon
import '@/framework/utils/error-log' // error log
import './permission' // permission control
import router from '@/framework/router'
import store from '@/framework/store'
import i18n from './i18n'



/**
 * 正式项目生产环境不需要mock，正式项目请将生产环境引入mock这段代码移除
 *
 */
if (process.env.NODE_ENV === 'production') {
  // const { mockXHR } = require('../mock')
  // mockXHR()
}
const mock = false;
if (mock) {
  // const { mockXHR } = require('../mock')
  // mockXHR();
}


Vue.use(Element, {
  size: Cookies.get('size') || 'mini' // set element-ui default size
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.config.devtools = true;
Vue.prototype.$eventBus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})

store.dispatch('app/getLangMessagesAction')